<template>
    <div>
        <div class="row">
            <img
                ref="image"
                src="@assets/images/banner-visitor-info.jpg"
                usemap="#image-map"
                alt=""
                class="w-100"
            />

            <map name="image-map">
                <area
                    target=""
                    alt=""
                    title=""
                    :href="createRoute"
                    :coords="
                        createX1 +
                        ',' +
                        createY1 +
                        ',' +
                        createX2 +
                        ',' +
                        createY2
                    "
                    shape="rect"
                />
                <area
                    target=""
                    alt=""
                    title=""
                    :href="
                        isAuthenticated ? '/my-account#schedule' : createRoute
                    "
                    :coords="
                        chooseX1 +
                        ',' +
                        generalY1 +
                        ',' +
                        chooseX2 +
                        ',' +
                        generalY2
                    "
                    shape="rect"
                />
                <area
                    target=""
                    alt=""
                    title=""
                    :href="
                        isAuthenticated && !!preferredFacility
                            ? '/schedule/inmate#anchor'
                            : isAuthenticated
                            ? '/my-account#schedule'
                            : createRoute
                    "
                    :coords="
                        scheduleX1 +
                        ',' +
                        generalY1 +
                        ',' +
                        scheduleX2 +
                        ',' +
                        generalY2
                    "
                    shape="rect"
                />
            </map>
        </div>

        <div class="normal-container py-5">
            <!-- TODO(Can this be reworded? This is a dangling participle.) -->
            <h1 class="text-center mb-5">
                Money Saving Remote And On-Site Visitation.
            </h1>
            <h2 class="text-primary text-center font-weight-normal">
                <strong>
                    Mobile Devices: All Apple<sup>®</sup>iPhones<sup>®</sup> &
                    iPads<sup>®</sup> and Android<sup>®</sup> smartphones and
                    tablets are compatible.
                </strong>
            </h2>

            <h2 class="text-primary text-center font-weight-normal my-5">
                <strong>
                    Desktops: All Windows<sup>®</sup> based PC's & MAC<sup
                        >®</sup
                    >
                    OSX Laptops and Desktop Computers are Compatible.
                </strong>
            </h2>
            <h2 class="text-secondary text-center my-5">
                For further detailed information, please see our
                <router-link
                    :to="{ name: 'system-requirements', hash: '#anchor' }"
                >
                    System Requirements
                </router-link>
            </h2>

            <testimonial class="pt-md-5"></testimonial>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Testimonial from '@/components/Testimonial.vue';

export default {
    components: { Testimonial },
    data() {
        return {
            windowWidth: window.innerWidth,
            height: null,
            width: null,
        };
    },
    computed: {
        ...mapState('Facility', ['facilities']),
        ...mapGetters('Facility', ['preferredFacility']),
        ...mapGetters('Auth', ['isAuthenticated']),

        createRoute() {
            return '/create-account';
        },
        /** Keep in mind the Y coordinates start from the top left corner
         *  and move DOWNWARDS on the coordinate plane */
        generalY1() {
            return this.height * 0.18;
        },
        generalY2() {
            return this.height * 0.4;
        },
        createX1() {
            return this.width * 0.36;
        },
        createX2() {
            return this.width * 0.44;
        },
        createY1() {
            return this.height * 0.2;
        },
        createY2() {
            return this.height * 0.47;
        },
        chooseX1() {
            return this.width * 0.57;
        },
        chooseX2() {
            return this.width * 0.66;
        },
        scheduleX1() {
            return this.width * 0.78;
        },
        scheduleX2() {
            return this.width * 0.89;
        },
    },
    created() {
        if (!this.facilities) {
            this.facilitiesRequest();
        }
    },
    mounted() {
        this.setDimensions();
        window.addEventListener('resize', this.resizeEvent);
        this.$nextTick(function () {
            setTimeout(this.fireResizeEvent, 2500);
        });
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.resizeEvent);
    },
    methods: {
        ...mapActions('Facility', ['facilitiesRequest']),

        resizeEvent() {
            this.windowWidth = window.innerWidth;
            this.setDimensions();
        },
        setDimensions() {
            setTimeout(() => {
                this.height = this.$refs.image.height;
                this.width = this.$refs.image.width;
            }, 1500);
        },
        fireResizeEvent() {
            window.dispatchEvent(new Event('resize'));
        },
    },
};
</script>
